import React, { useEffect, useState } from "react";
import "./StdAssignment.css";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

function Assignment() {
  const navigate = useNavigate();
  const [assignmentRows, setAssignmentRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const pageCount = Math.ceil(assignmentRows.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  useEffect(() => {
    const fetchAssignments = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId") || "";
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!studentId) {
        setError("Student session details are missing. Please log in again.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const queryParams = new URLSearchParams();
        if (academicYearId) queryParams.append("academic_year_id", academicYearId);
        if (orgId) queryParams.append("org_id", orgId);
        if (branchId) queryParams.append("branch_id", branchId);

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentAssignments/${studentId}/?${queryParams.toString()}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load assignments.");
        }

        setAssignmentRows(Array.isArray(payload.data) ? payload.data : []);
      } catch (fetchError) {
        console.error("Error fetching assignments:", fetchError);
        setAssignmentRows([]);
        setError(fetchError.message || "Unable to load assignments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAssignments();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ASSIGNMENT SUMMARY
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="col-12 container-fluid mt-4">
                {loading ? (
                  <div className="text-center py-4">Loading assignments...</div>
                ) : error ? (
                  <div className="alert alert-danger mb-0">{error}</div>
                ) : (
                  <>
                  <div className="table-responsive">
                    <table className="table table-bordered student-assignment-table-fixed">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Subject</th>
                          <th>Period</th>
                          <th>Teacher</th>
                          <th className="student-assignment-details-column">Assignment Details</th>
                          <th>Attachment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {assignmentRows.length > 0 ? (
                          assignmentRows
                            .slice(currentPage * itemsPerPage, currentPage * itemsPerPage + itemsPerPage)
                            .map((row, index) => (
                              <tr key={row.id || row.sr_no || index}>
                                <td>{currentPage * itemsPerPage + index + 1}</td>
                                <td>{row.date || "-"}</td>
                                <td>{row.subject || row.subject_code || "-"}</td>
                                <td>{row.period || "-"}</td>
                                <td>{row.teacher || row.professor || "-"}</td>
                                <td className="student-assignment-details-column">
                                  <div className="student-assignment-details-text">
                                    {row.assignment_details || "-"}
                                  </div>
                                </td>
                                <td>
                                  {row.attachment_url ? (
                                    <a
                                      href={row.attachment_url}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      View
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No assignments available for this student
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {assignmentRows.length > 0 && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center mt-3"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Assignment;
